import { render } from "./FormularioComponent.vue?vue&type=template&id=2c1aafc7&scoped=true&ts=true"
import script from "./FormularioComponent.vue?vue&type=script&lang=ts"
export * from "./FormularioComponent.vue?vue&type=script&lang=ts"

import "./FormularioComponent.vue?vue&type=style&index=0&id=2c1aafc7&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1aafc7"]])

export default __exports__